import { useState } from 'react'
// import isWebview from 'is-ua-webview'
import { useIsomorphicLayoutEffect } from 'react-use'

// TODO
// Add webview detection if needed

export const useHeaderFooter = () => {
  const [isInIframe, setIsInIframe] = useState(false)
  // const [isInWebview, setIsInWebview] = useState(false)

  useIsomorphicLayoutEffect(() => {
    if (window.self !== window.top) {
      setIsInIframe(true)
    }

    // if (isWebview(window.navigator.userAgent)) {
    //   setIsInWebview(true)
    // }
  }, [])

  // return isInIframe || isInWebview
  return isInIframe
}
